import React from "react";

import { faCircleNotch } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "src/design-system/Icon";

/**
 * @deprecated please use placeholders instead
 */
export const Spinner: React.FC = () => {
  return (
    <div className="mx-auto my-auto">
      <Icon icon={faCircleNotch} size="md" spin />
    </div>
  );
};
